const STATUS_COLORS = {
  completed: 'bg-green-100 text-green-700',
  pending:   'bg-yellow-100 text-yellow-700',
  failed:    'bg-red-100 text-red-700',
};

export default function PaymentsTable({ payments = [] }) {
  if (payments.length === 0) {
    return <p className="text-sm text-[#9CA3AF] font-body">No payment records found</p>;
  }

  const totalPaid = payments
    .filter((p) => p.status === 'completed')
    .reduce((sum, p) => sum + Number(p.amount || 0), 0);
  const completedCount = payments.filter((p) => p.status === 'completed').length;
  const pendingCount   = payments.filter((p) => p.status === 'pending').length;

  return (
    <div className="space-y-4">
      {/* Summary bar */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="bg-white border border-[#E8E6F8] rounded-xl p-4 text-center">
          <p className="text-[10px] font-body text-[#9CA3AF] uppercase tracking-widest mb-1">Total Paid</p>
          <p className="text-xl font-heading font-black text-[#6C63FF]">
            ₹{totalPaid.toLocaleString('en-IN')}
          </p>
        </div>
        <div className="bg-white border border-[#E8E6F8] rounded-xl p-4 text-center">
          <p className="text-[10px] font-body text-[#9CA3AF] uppercase tracking-widest mb-1">Completed</p>
          <p className="text-xl font-heading font-black text-green-600">{completedCount}</p>
        </div>
        <div className="bg-white border border-[#E8E6F8] rounded-xl p-4 text-center">
          <p className="text-[10px] font-body text-[#9CA3AF] uppercase tracking-widest mb-1">Pending</p>
          <p className="text-xl font-heading font-black text-yellow-600">{pendingCount}</p>
        </div>
      </div>

      {/* Payments table */}
      <div className="overflow-x-auto rounded-xl border border-[#E8E6F8]">
        <table className="w-full text-sm font-body">
          <thead>
            <tr className="bg-[#F5F4FB] border-b border-[#E8E6F8]">
              {['Amount', 'Currency', 'Status', 'Payment ID', 'Method', 'Paid At'].map((h) => (
                <th key={h} className="px-4 py-3 text-left text-xs font-heading font-semibold text-[#6B7280]">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E8E6F8]">
            {payments.map((p) => (
              <tr key={p.id} className="bg-white hover:bg-[#F5F4FB]">
                <td className="px-4 py-3 font-heading font-bold text-[#1A1A2E]">
                  ₹{Number(p.amount).toLocaleString('en-IN')}
                </td>
                <td className="px-4 py-3 text-[#6B7280]">{p.currency || 'INR'}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2.5 py-0.5 rounded-full font-medium ${STATUS_COLORS[p.status] || 'bg-gray-100 text-gray-600'}`}>
                    {p.status}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs text-[#9CA3AF]">{p.payment_id || '–'}</td>
                <td className="px-4 py-3 text-xs text-[#9CA3AF]">{p.payment_method || '–'}</td>
                <td className="px-4 py-3 text-xs text-[#9CA3AF] whitespace-nowrap">
                  {p.paid_at ? new Date(p.paid_at).toLocaleString('en-IN') : '–'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
